import propTypes from "prop-types"
import { useEffect, useCallback } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useMutation } from "@tanstack/react-query"

import { ImportForm } from "components"
import { masiveImportProviders } from "services/providers"
import { useDownloadTemplate } from "hooks/use-download-template"

const ImportModalForm = ({ isOpen, toggle, setShowAlertSuccess, setMsgSuccess }) => {
  const downloadTemplate = useCallback(() => {
    useDownloadTemplate("/providers/download_template")
  }, [])
  const { data, error, isError, isLoading, isSuccess, mutateAsync } = useMutation(masiveImportProviders)

  const submit = async (data) => {
    await mutateAsync(data)
  }

  useEffect(() => {
    if (isSuccess) {
      setMsgSuccess(
        `Importación realizada satisfactoriamente <br/> <br/> Proveedores importados: ${
          data?.created?.length + data?.updated?.length
        } <br/> Proveedores no importados: ${data?.errors?.length} <br/> <br/>
        <a href="/logs-importation/${data?.log_id}">Ver más</a>
        `
      )
      setShowAlertSuccess(true)
      toggle()
    }
  }, [isSuccess])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Importar Proveedores
      </ModalHeader>
      <ModalBody>
        <div>
          <ImportForm
            submit={submit}
            isError={isError}
            error={error}
            isLoading={isLoading}
            toggle={toggle}
            downloadTemplate={downloadTemplate}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

ImportModalForm.propTypes = {
  isOpen: propTypes.bool.isRequired,
  toggle: propTypes.func.isRequired,
  setShowAlertSuccess: propTypes.func.isRequired,
  setMsgSuccess: propTypes.func.isRequired,
}

export default ImportModalForm
